import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import style from './language-selection-dropdown.less';
import messages from './messages';

const LanguageSelectionDropdown = ({ availableLocales, onLocaleChange, currentLocale }) => {
  return (
    <DropdownMenu dropdownMenuShouldHaveWidthOfButton>
      <DropdownMenuToggler className={style['toggler-button']} theme='white'>
        <FormattedMessage {...messages[currentLocale]} />
      </DropdownMenuToggler>
      {availableLocales.map((locale) => {
        return (
          <DropdownMenuItem key={locale} id={locale} onClick={() => onLocaleChange(locale)} selected={currentLocale === locale}>
            <FormattedMessage {...messages[locale]} />
          </DropdownMenuItem>
        );
      })}
    </DropdownMenu>
  );
};

LanguageSelectionDropdown.propTypes = {
  availableLocales: PropTypes.array.isRequired,
  onLocaleChange: PropTypes.func.isRequired,
  currentLocale: PropTypes.string.isRequired,
};

export default LanguageSelectionDropdown;
